import { EnvironmentServiceProvider } from './environmentService.provider';

export default angular
  .module('ng1-environment', [])
  .provider('envService', EnvironmentServiceProvider)
  .name;
